const prefix = 'SETTING_EMAIL_'

export const SETTING_EMAIL_PAGE_REQUEST = `${prefix}PAGE_REQUEST`

export const SETTING_EMAIL_SUBMIT_FORM = `${prefix}SUBMIT_FORM`

export const SETTING_EMAIL_SET_PROFILE = `${prefix}SET_PROFILE`

export const SETTING_EMAIL_SHOW_RECIPIENT_MODAL = `${prefix}SHOW_RECIPIENT_MODAL`

export const SETTING_EMAIL_HIDE_RECIPIENT_MODAL = `${prefix}HIDE_RECIPIENT_MODAL`

export const SETTING_EMAIL_CHANGE_PAGE = `${prefix}CHANGE_PAGE`

export const SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS = `${prefix}ON_CANCEL_MANAGE_RECIPIENTS`

export const SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS = `${prefix}ON_CLICK_MANAGE_RECIPIENTS`

export const SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM = `${prefix}SET_PREVIOUS_EMAIL_NOTIFICATION_FORM`

export const SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS = `${prefix}ON_CONFIRM_MANAGE_RECIPIENTS`

export const SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS = `${prefix}SHOW_SETTING_ALERT_RECIPIENTS_ERRORS`

export const SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS = `${prefix}HIDE_SETTING_ALERT_RECIPIENTS_ERRORS`

export const SETTING_EMAIL_ON_CLICK_DELETE_ICON = `${prefix}ON_CLICK_DELETE_ICON`

export const SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL = `${prefix}SHOW_DELETE_RECIPIENT_MODAL`

export const SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL = `${prefix}HIDE_DELETE_RECIPIENT_MODAL`

export const SETTING_EMAIL_CANCEL_DELETE_RECIPIENT = `${prefix}CANCEL_DELETE_RECIPIENT`

export const SETTING_EMAIL_DELETE_RECIPIENT = `${prefix}DELETE_RECIPIENT`

export const SETTING_EMAIL_SET_DELETED_RECIPIENT = `${prefix}SET_DELETED_RECIPIENT`



// WEBPACK FOOTER //
// ./app/actions/setting/emailNotification/constants.js